module.exports = __webpack_public_path__ + "static/media/technology.17fdca29.png";